import { UIText1, UIText2, ModalWindow } from '@cian/ui-kit';
import { IconFunctionalInformation16 } from '@cian/ui-kit-design-tokens/icons';
import { reloadPage } from '@cian/valuation-utils-component';
import * as React from 'react';

import { TAboutNearbyHousesData } from '../../../../types/offerHistory';
import { Error, Loading, KeyValTable } from '../commonComponents';
import * as styles from './styles.css';

interface IAboutNearbyHousesProps {
  aboutNearbyHousesData: TAboutNearbyHousesData | null;
  isError?: boolean;
  isLoading?: boolean;
  isModalOpened: boolean;
  onModalClose(): void;
  onModalOpen(): void;
}

export const AboutNearbyHouses: React.FC<IAboutNearbyHousesProps> = props => {
  const { isModalOpened, onModalClose, onModalOpen, aboutNearbyHousesData, isError, isLoading } = props;

  return (
    <>
      <button type="button" onClick={onModalOpen} className={styles['button']}>
        <IconFunctionalInformation16 color="icon-main-default" display="block" />
        <UIText2 color="text-main-default">Как определяем соседние дома</UIText2>
      </button>
      <ModalWindow
        open={isModalOpened}
        onClose={onModalClose}
        size="M"
        title="Как определяем соседние дома"
        content={
          <>
            {isError && <Error handleClick={reloadPage} />}
            {isLoading && <Loading />}
            {aboutNearbyHousesData && (
              <>
                <UIText1>
                  Соседними называем максимально похожие дома, расположенные поблизости. Эти дома удовлетворяют
                  критериям:
                </UIText1>
                <KeyValTable className={styles['features']} table={aboutNearbyHousesData.features} />
              </>
            )}
          </>
        }
      />
    </>
  );
};
